/**
 * Carrier Logo options for ComplianceCarrierLogoId (Spec 0039 M-5).
 *
 * Zentrale Konstante — wird spaeter (Phase 2: DynamoDB-CRUD)
 * durch einen API-Aufruf ersetzt. Bis dahin statisch.
 *
 * Carrier brand names (ids 1–4) are data and stay identical in every language.
 * The descriptive options (ids 5/10/11) carry an i18n `labelKey` (namespace `common`);
 * `label` is the plain fallback used outside a translation context.
 */
export interface CarrierLogoOption {
  id: number;
  /** Plain fallback label (brand name, or non-localised fallback for descriptive entries). */
  label: string;
  /** Optional i18n key (namespaced) for descriptive labels that must follow the language. */
  labelKey?: string;
}

export const CARRIER_LOGO_OPTIONS: readonly CarrierLogoOption[] = [
  { id: 1, label: 'Telekom' },
  { id: 2, label: 'Vodafone' },
  { id: 3, label: 'Telefonica (O2)' },
  { id: 4, label: 'Freenet' },
  { id: 5, label: 'Pay simply (grey, no MNO)', labelKey: 'common:carrierLogo.grey' },
  { id: 10, label: 'DE combo (T/V/O)', labelKey: 'common:carrierLogo.deCombo' },
  { id: 11, label: 'DE all (T/V/O/F)', labelKey: 'common:carrierLogo.deAll' },
] as const;

/**
 * Resolve a CarrierLogoId to its plain fallback label (no i18n).
 * Returns undefined if the ID is unknown.
 */
export function getCarrierLogoLabel(id: number | undefined): string | undefined {
  if (id === undefined) return undefined;
  return CARRIER_LOGO_OPTIONS.find((opt) => opt.id === id)?.label;
}

/**
 * Resolve a CarrierLogoId to its display label, translating descriptive entries via `t`.
 * Brand names (no `labelKey`) return their plain `label`. Returns undefined for unknown ids.
 */
export function resolveCarrierLogoLabel(
  id: number | undefined,
  t: (key: string) => string,
): string | undefined {
  if (id === undefined) return undefined;
  const opt = CARRIER_LOGO_OPTIONS.find((o) => o.id === id);
  if (!opt) return undefined;
  return opt.labelKey ? t(opt.labelKey) : opt.label;
}
